<div
  [ngClass]="{
    'form-floating': !noLabel
  }"
  *appLet="{
    appCopy: appCopy$ | async,
    isMobile: isMobile$ | async
  } as $comp"
>
  @if (!rangePicker) {
    <input
      *ngIf="formControl"
      type="text"
      [id]="id"
      [name]="name"
      [attr.data-qa]="id"
      [formControl]="formControl"
      [placeholder]="required ? (label | requiredField) : label"
      class="form-control"
      #datePicker="bsDatepicker"
      bsDatepicker
      [minDate]="minDateAsDate"
      [maxDate]="maxDateAsDate"
      [datesEnabled]="datesEnabled"
      [dateCustomClasses]="dateClasses"
      [bsConfig]="{
        dateInputFormat: bootstrapFormat,
        displayOneMonthRange: true,
        containerClass: theme + ' norse ' + (extraClasses ?? ''),
        isAnimated: isAnimated,
        adaptivePosition: adaptivePosition,
        showWeekNumbers: false,
        dayLabel: 'd',
      }"
      [placement]="placement"
      [required]="required"
      [readonly]="$comp.isMobile ?? false"
    />
  } @else {
    <input
      *ngIf="formControl"
      type="text"
      [id]="id"
      [name]="name"
      [attr.data-qa]="id"
      [formControl]="formControl"
      [placeholder]="required ? (label | requiredField) : label"
      class="form-control {{inputClass}}"
      #dateRangePicker="bsDaterangepicker"
      bsDaterangepicker
      [minDate]="minDateAsDate"
      [datesEnabled]="datesEnabled"
      [dateCustomClasses]="dateClasses"
      [bsConfig]="{
        displayOneMonthRange: true,
        containerClass: theme + ' norse ' + (extraClasses ?? ''),
        isAnimated: isAnimated,
        adaptivePosition: adaptivePosition,
        showWeekNumbers: false,
        displayMonths: displayMonths,
      }"
      [placement]="placement"
      [required]="required"
      [readonly]="$comp.isMobile ?? false"
      (bsValueChange)="onDateRangeSelected($event)"
    />
  }
  <ng-container *ngTemplateOutlet="inputLabel"></ng-container>
  <ng-container *ngTemplateOutlet="errors"></ng-container>

  <ng-template #inputLabel>
    <label *ngIf="label && !noLabel" [for]="id" class="form-label">
      {{ required ? (label | requiredField) : label }}
    </label>
  </ng-template>

  <ng-template #errors>
    <app-input-errors
      *ngIf="control && $comp.appCopy"
      [control]="control"
      [suppressErrors]="suppressErrors"
      [extraErrors]="extraErrors"
      [errors]="$comp.appCopy.errors"
    ></app-input-errors>
  </ng-template>
</div>
